import { ExtensionSubMenu } from "trimble-connect-project-workspace-api"
import GetEnvironment from "../environments"
import { ConfigStatus } from "../components/Config/ConfigMain"
import { TCExtensionAPI } from "trimble-connect-project-workspace-api"

const iconsRootUrl = window.location.origin

export const setMenu = (t: any, projectStatus: ConfigStatus | undefined, extensionApi: TCExtensionAPI | undefined) => {
  if (!extensionApi) {
    console.error("setMenu - extensionApi is undefined")
    return
  }

  const enableObjectModelConfig = GetEnvironment().enableObjectModelConfig
  console.log("setMenu - enableObjectModelConfig", enableObjectModelConfig)
  console.log("setMenu - projectStatus", projectStatus)

  // if the the object model config is not enabled and the status is not Active or Updating, dont add the menu
  const active = projectStatus === "Active" || projectStatus === "Updating"
  console.log("setMenu - active", active)
  if (!enableObjectModelConfig && !active) {
    console.log("setMenu - Object Model Config is not enabled and project status is not Active or Updating")
    return
  }

  const menu = {
    title: t("sharedModel") + (GetEnvironment().envName ? ` - ${GetEnvironment().envName}` : ""),
    icon: `${iconsRootUrl}/Quadri_24.svg`,
    command: "objectmodelconfig",
    subMenus: [] as ExtensionSubMenu[]
  }

  if (active) {
    menu.subMenus = [
      {
        title: t("tasks"),
        icon: `${iconsRootUrl}/Libraries_16.svg`,
        command: "tasks"
      },
      {
        title: t("timeline"),
        icon: `${iconsRootUrl}/Activity_16.svg`,
        command: "timeline"
      },
      {
        title: t("worksets"),
        icon: `${iconsRootUrl}/Cloud_16.svg`,
        command: "worksets"
      }
    ] as ExtensionSubMenu[]
  }

  if (enableObjectModelConfig && active) {
    menu.subMenus?.push({
      title: t("settings"),
      icon: `${iconsRootUrl}/Settings_16.svg`,
      command: "objectmodelconfig"
    })
  }

  console.log("setMenu - ready to set menu", menu)

  extensionApi.ui.setMenu(menu)
}
